import { AbstractControl, FormControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import moment from 'moment'


// form group functions

/**
 * date validator: MM/DD/YYYY and
 * check if user >= 18 years old but not older than 120
 */
function isDateValidator(): ValidatorFn {
  const MDY_FORMAT = 'MM/DD/YYYY'
  return (control: AbstractControl): { [key: string]: any } | null => {
    const years18Ago = moment().subtract(18, 'years')
    const years120Ago = moment().subtract(120, 'years')
    // check no valid date
    const inputDateMoment = moment(control.value, MDY_FORMAT, false)
    let forbidden = !inputDateMoment.isValid()
    // check if user >= 18 years old but not older than 120
    if (!forbidden && (inputDateMoment.toDate() > years18Ago.toDate()
      || inputDateMoment.toDate() < years120Ago.toDate())) {
      forbidden = true
    }
    return forbidden ? { forbiddenName: { value: control.value } } : null
  }
}

/**
 * amount validator:
 * check is 1000 <= value <= 7500
 */
function amountValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) { return null }
    const clearTextValue: number = +(control.value.toString().split(',').join('').split('$').join(''))
    if(control?.parent?.value?.state === "HI"){
      if (clearTextValue < 1600) {
        return { forbiddenName: { value: control.value } }
      }
    }
    if (clearTextValue >= 1000 && clearTextValue <= 7500) {
      return null
    }
    return { forbiddenName: { value: control.value } }
  }
  // return (control: AbstractControl): { [key: string]: any } | null => {
  //   if (!control?.value) { return null } 
  //   if(control?.parent?.value?.state === "HI"){
  //     const clearTextValue: number = +(control.value.toString().split(',').join('').split('$').join(''))
  //   if (clearTextValue && clearTextValue < 1600) {
  //     return null 
  //   }
  //   }
  //   return { forbiddenName: { value: control.value } }
  // }
}


/**
 * create form group and set all validators
 */
export function makeFormGroup(that): UntypedFormGroup {
  // alfa + space + dash
  const ALPHABET_SPACE_DASH_REGEX = /^[A-Za-z\s\-]+$/
  const ALPHABET_SPACE_DASH_UPCOMMA_REGEX = /^[A-Za-z\s\-']+$/
  // numbers can starts with $
  const NUMERIC_REGEX = /^\$?[1-9][0-9\,]+$/
  return new UntypedFormGroup({
    firstName: new UntypedFormControl(that.loanInfo.firstName, {
      validators: [
        Validators.required,
        Validators.pattern(ALPHABET_SPACE_DASH_UPCOMMA_REGEX),
        Validators.minLength(2),
      ], updateOn: 'blur'
    }),
    secondName: new UntypedFormControl(that.loanInfo.lastName, {
      validators: [
        Validators.required,
        Validators.pattern(ALPHABET_SPACE_DASH_UPCOMMA_REGEX),
        Validators.minLength(2)
      ],
      updateOn: 'blur'
    }),
    address: new UntypedFormControl(that.loanInfo.address.address1, {
      validators: [
        Validators.required,
        Validators.minLength(1)
      ],
      updateOn: 'blur'
    }),
    city: new UntypedFormControl(that.loanInfo.address.city, {
      validators: [
        Validators.required,
        Validators.pattern(ALPHABET_SPACE_DASH_REGEX),
        Validators.minLength(3)
      ],
      updateOn: 'blur'
    }),
    state: new UntypedFormControl(that.loanInfo.address.state, {
      validators: [
        Validators.required,
        Validators.minLength(2)
      ],
      updateOn: 'blur'
    }),
    zipCode: new UntypedFormControl(that.loanInfo.address.zipCode, {
      validators: [
        Validators.required,
        Validators.pattern(/^\d{5}$/)
      ],
      updateOn: 'blur'
    }),
    socNumber: new UntypedFormControl(that.loanInfo.ssn, {
      validators: [
        Validators.required,
        Validators.minLength(11),
        Validators.pattern(/^\d{3}-\d{2}-\d{4}$/),
        Validators.maxLength(11)
      ],
      updateOn: 'blur'
    }),
    dateOfBirth: new UntypedFormControl(that.loanInfo.dateOfBirth, {
      validators: [
        Validators.required,
        Validators.pattern(/^[0-1]{0,1}[0-9]\/[0-3]{0,1}[0-9]\/\d{4}$/),
        Validators.minLength(3),
        isDateValidator()
      ],
      updateOn: 'blur'
    }),
    mobile: new UntypedFormControl(that.loanInfo.mobile, {
      validators: [
        Validators.required,
        Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)
      ],
      updateOn: 'blur'
    }),
    income: new UntypedFormControl(that.loanInfo.annualIncome, {
      validators: [
        Validators.required,
        Validators.pattern(NUMERIC_REGEX),
        Validators.minLength(3)
      ],
      updateOn: 'blur'
    }),
    // amount: new FormControl(null , {
    //   validators: [ 
    //     // Validators.required,
    //     Validators.pattern(NUMERIC_REGEX),
    //     // Validators.minLength(6),
    //     Validators.maxLength(6),
    //     // amountValidator()
    //   ],
    //   updateOn: 'blur'
    // }),
    cb: new UntypedFormControl(false, [
      Validators.requiredTrue
    ])
  })
}
